import * as React from 'react';
import { observer } from 'mobx-react';

import { appStore } from '@app/Stores/AppStore';
import { DateTimeService } from '@app/Services/DateTimeService';
import ScenePlaceholder from '@app/Components/ScenePlaceholder';

@observer
export class Forbidden extends React.Component<{}, {}> {
    public render() {
        const name = appStore.currentUserName;
        const impersonation = appStore.permissionImpersonation;

        return (
            <ScenePlaceholder mainClass="page-forbidden">
                <h1>403</h1>
                <h2>Forbidden</h2>
                <p>
                    {name ? `Hi, ${name}!` : 'Hi!'} <br /> You don't have access to this page.
                </p>
                {impersonation && (
                    <p className="tal">
                        <small>
                            <strong>Impersonating:</strong> {impersonation.permissionIds.length} permission{impersonation.permissionIds.length === 1 ? '' : 's'}
                        </small>
                    </p>
                )}
                <p className="tal">
                    <small>
                        <strong>Timestamp:</strong> {DateTimeService.format(DateTimeService.now(), 'YYYY-MM-DD HH:mm:ss')}
                    </small>
                </p>
            </ScenePlaceholder>
        );
    }
}
